import React, { useState } from "react";
import { Hidden, IconButton, Menu, MenuItem } from "@mui/material";
import { LockOpen } from "@mui/icons-material";
import { logoutUser } from "../../Redux/Actions/authAction";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import CropFreeIcon from "@mui/icons-material/CropFree";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { GET_LOCAL_STORAGE } from "Components/Constants/GetLocalStorage";
import { company } from "titum-custom/details";
import BackupService from "Service/Accounts/Backup.service";
import useMediaQuery from "@mui/material/useMediaQuery";
import MobileShortcuts from "./ShortcutMenu";

export default function LogoutMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);

  const [fullScreen, setFullScreen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    dispatch(logoutUser());
  };

  const handleBackup = async () => {
    const res = await BackupService.download();
  };

  var elem = document.documentElement;
  function openFullscreen() {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
    setFullScreen(true);
  }
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
    setFullScreen(false);
  }
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <div style={{ position: "absolute", right: 15 }}>
      <Hidden only={["xs", "sm"]}>
        Location:{" "}
        {JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}
      </Hidden>
      <IconButton
        color="inherit"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={() => {
          !fullScreen ? openFullscreen() : closeFullscreen();
        }}
        sx={{ display: isMobile && "none" }}
      >
        <Hidden only={["xs", "sm"]}>
          <p
            style={{
              marginLeft: 5,
              marginRight: 5,
              textTransform: "uppercase",
            }}
          >
            {!fullScreen ? "Full Screen  [ F11 ]" : "Close  [ F11 ]"}
          </p>
          {!fullScreen ? <CropFreeIcon /> : <CloseFullscreenIcon />}
        </Hidden>
      </IconButton>

      <IconButton
        color="inherit"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Hidden only={["xs"]}>
          <p
            style={{
              marginLeft: 5,
              marginRight: 5,
              textTransform: "uppercase",
            }}
          >
            {" "}
            {props.user}
          </p>
        </Hidden>
        
        <LockOpen />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <a href={company.backup} target="_blank">
          <MenuItem style={{ color: "blue" }}>Backup</MenuItem>
        </a>
        <NavLink to="settings" exact>
          <MenuItem>Settings</MenuItem>
        </NavLink>
        <MenuItem onClick={handleClose}>Logout</MenuItem>
      </Menu>
    </div>
  );
}
